import { Box, Heading } from 'theme-ui';
import { useSettings } from '@backpackjs/storefront';

import { Link } from '@snippets';
import { useIsEuVisitor } from '@hooks';

import { themed } from './WithdrawalCta.theme';

export const WithdrawalCta = themed(({ theme, className }) => {
  const settings = useSettings();
  const { isEu, isLoading } = useIsEuVisitor();
  const withdrawalCta = settings?.footer?.withdrawalCta;
  const heading = withdrawalCta?.heading || 'EU Right of Withdrawal';
  const title = withdrawalCta?.title || 'Cancel My Contract';
  const url = withdrawalCta?.url || '/pages/eu-cancel-order';

  // if (isLoading || !isEu || !title || !url) return null;
  if (isLoading || !isEu) return null;

  return (
    <Box
      data-comp={WithdrawalCta.displayName}
      sx={theme.wrapper}
      className={className}
    >
      {heading && (
        <Heading as="h3" sx={theme.heading}>
          {heading}
        </Heading>
      )}

      <Link variant="buttons.inverse" href={url} sx={theme.button}>
        {title}
      </Link>
    </Box>
  );
});

WithdrawalCta.displayName = 'WithdrawalCta';
